export {default} from "./content";
